import React from 'react';
import '../components/styles/footer.css';
import { Link } from 'react-router-dom';
import { 
  Facebook, 
  Instagram, 
  Youtube, 
  Twitter, 
  Linkedin, 
  Mail, 
  HelpCircle, 
  Newspaper, 
  Gamepad2,
  Trophy
} from 'lucide-react';

function Footer() {
  return (
    <footer className='footer-container'>
      <div className='footer-content'>
        {/* Main Footer Section */}
        <div className='footer-main'>
          {/* Logo and Description */}
          <div className='footer-brand'>
            <Link to="/" className="footer-logo-link">
              <img className="footer-logo" src="../images/chedagaming_logo.png" alt="Cheda Gaming Logo"/>
            </Link>
            <p className="footer-description">
              Building an ecosystem of connecting gamers all over Africa. 
              Earn while playing or hosting online tournaments.
            </p>
            <div className="footer-socials">
              <Link
                className='social-link facebook'
                to='https://www.facebook.com/chedagaming'
                target='_blank'
                aria-label='Facebook'
              >
                <Facebook size={20} />
              </Link>
              <Link
                className='social-link instagram'
                to='https://www.instagram.com/chedagaming'
                target='_blank'
                aria-label='Instagram'
              >
                <Instagram size={20} />
              </Link>
              <Link
                className='social-link youtube'
                to='https://www.youtube.com/chedagaming'
                target='_blank'
                aria-label='Youtube'
              >
                <Youtube size={20} />
              </Link>
              <Link
                className='social-link twitter'
                to='https://www.twitter.com/chedagaming'
                target='_blank'
                aria-label='Twitter'
              >
                <Twitter size={20} />
              </Link>
              <Link
                className='social-link linkedin'
                to='https://www.linkedin.com/company/cheda-gaming'
                target='_blank'
                aria-label='LinkedIn'
              >
                <Linkedin size={20} />
              </Link>
            </div>
          </div>

          {/* Quick Links */}
          <div className='footer-links'>
            <div className='footer-section-group'>
              <h3 className='footer-section-title'>
                <Trophy size={18} />
                <span>About Us</span>
              </h3>
              <ul className='footer-link-list'>
                <li>
                  <Link to='/news'>
                    <Newspaper size={16} />
                    <span>News</span>
                  </Link>
                </li>
                {/* <li>
                  <Link to='/about'>
                    <Users size={16} />
                    <span>Our Story</span>
                  </Link>
                </li> */}
                <li>
                  <Link to='https://wa.link/uhba1k'>
                    <HelpCircle size={16} />
                    <span>Help Center</span>
                  </Link>
                </li>
              </ul>
            </div>

            <div className='footer-section-group'>
              <h3 className='footer-section-title'>
                <Gamepad2 size={18} />
                <span>Contact Us</span>
              </h3>
              <div className='footer-contact'>
                <p className='footer-contact-text'>
                  Building an ecosystem of connecting gamers all over Africa.
                </p>
                <Link to='mailto:support@chedagaming.com' className='footer-email'>
                  <Mail size={16} />
                  <span>support@chedagaming.com</span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className='footer-bottom'>
          <div className='footer-divider'></div>
          <div className='footer-bottom-content'>
            <p className='footer-copyright'>
              © 2024 Cheda Gaming. All rights reserved.
            </p>
            <div className='footer-legal'>
              <Link to='/policy'>Privacy Policy</Link>
              <Link to='/terms'>Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
